module.exports = __webpack_public_path__ + "static/media/log-out.092224fa.svg";